function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import CareLocaleKeys from '../../../../../../locales/keys';
import { TAX_LOCATION_CUSTOM_OPTIONS } from '../../../../../../customercare.constants';
import { CurrentAddressesSelector } from '../../../../../../reducers/selectors/customer.addresses.selectors';
import { addressHelper as AddressHelper } from 'invision-core/src/utilities/address.helper';
import { updateCustomizedServiceTax } from '../../../../../../reducers/actions/services.actions';
import { CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
var ServiceTaxDetailsController = /*#__PURE__*/function () {
  function ServiceTaxDetailsController($ngRedux) {
    _classCallCheck(this, ServiceTaxDetailsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CareLocaleKeys: CareLocaleKeys,
      getFormattedAddress: this.getFormattedAddress.bind(this),
      TAX_LOCATION_CUSTOM_OPTIONS: TAX_LOCATION_CUSTOM_OPTIONS
    });
  }
  return _createClass(ServiceTaxDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        updateCustomizedServiceTax: updateCustomizedServiceTax
      };
      var mapStateToProps = function mapStateToProps(state) {
        return {
          currentAddresses: CurrentAddressesSelector(state),
          currentCustomerId: CurrentCustomerIdSelector(state)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.serviceTaxDetails.currentValue) {
        this.originatingPercentage = this.serviceTaxDetails.OriginatingPercentage && this.serviceTaxDetails.OriginatingPercentage < 1 ? parseInt(this.serviceTaxDetails.OriginatingPercentage * 100) : null;
        this.remainingPercentage = this.originatingPercentage ? 100 - this.originatingPercentage : 100;
      }
    }
  }, {
    key: "getFormattedAddress",
    value: function getFormattedAddress(addressId) {
      return this.state.currentAddresses.length ? AddressHelper.createBillingAddressString(clone(this.state.currentAddresses.find(function (thisAddress) {
        return thisAddress.Id === addressId;
      }))) : '';
    }
  }]);
}();
export default {
  bindings: {
    serviceTaxDetails: '<'
  },
  template: require('./service.tax.details.template.html'),
  controller: ServiceTaxDetailsController,
  controllerAs: 'ServiceTaxDetailsController'
};